import React from 'react';
import { Link } from 'react-router-dom';
import Lottie from 'react-lottie-player/dist/LottiePlayerLight';
import { Divider } from 'antd';
import reactCSS from 'reactcss';
import lottieJson from '../../../animations/lottie/login.json';
import LoginForm from '../../../components/general/general/login/LoginForm';

import './styles/login.css';

const logo = 'https://cdn.ased.gob.mx/buzon/images/easewhite.png';
const Login = () => {
    document.body.style.backgroundColor = '#e8e8e8';

    const styles = reactCSS({
        default: {
            cover: { position: 'relative' },
            center: {
                position: 'absolute',
                top: '89%',
                width: '90%',
                textAlign: 'right',
                fontSize: '18px',
            },
            color: {
                backgroundColor: 'rgba(231, 214, 0,0.5)',
                width: '100%',
                height: 'auto',
                opacity: '0.3',
            },
        },
    });

    return (
        <div className="d-flex flex-column justify-content-center" style={{ height: '100vh' }}>
            <div className="container shadow card p-3 p-md-0 animate__animated animate__bounceInDown" style={{ borderRadius: 0, overflow: 'hidden', height: 'fit-content' }}>
                <div className="row align-items-center">
                    <div className="col-12 col-md-6 text-center p-0">
                        <h1 className="font-weight-bold">Buzón Digital</h1>
                        <h4>Inicio de sesión</h4>
                        <p>Por favor, ingresa tus credenciales para acceder.</p>
                        <LoginForm />
                        <Link to="/recuperar" className="font-weight-bold">Olvidé mi contraseña</Link>

                        <Divider />
                        <div className="d-flex flex-column">
                            <p className="font-weight-bold">
                                ¿Tienes alguna duda?
                                {' '}
                                <a target="_blank" rel="noreferrer" href="https://ease.gob.mx/index.php#contacto">
                                    Contáctanos
                                </a>
                            </p>
                            <a className="mt-2" target="_blank" rel="noreferrer" href="https://ease.gob.mx/assets/pdf/AVISODEPRIVACIDADINTEGRALYSIMPLIFICADOBUZON.pdf">
                                Aviso de privacidad
                            </a>
                        </div>
                    </div>
                    <div className="col-12 col-md-6  m-0 p-0 d-none d-md-block" style={{ backgroundColor: '#004BFF' }}>
                        <Lottie
                            className="m-0 p-0 estilo"
                            loop
                            animationData={lottieJson}
                            play
                        />

                        <div style={styles.popover}>
                            <div style={styles.cover} />
                            <div style={styles.center}>
                                <img src={logo} style={{ filter: 'invert(1) brightness(200%)' }} alt="Logotipo de la ASED" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Login;
